import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography
} from '@mui/material';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';

import { useClientZS } from '../../../pages/ClientZS';

const InfoField = ({ label, value }) => (
  <Box flex={1}>
    <Typography
      variant="body2"
      color="text.secondary"
      gutterBottom
    >
      {label}
    </Typography>

    <Typography fontWeight={600}>
      {value || '-'}
    </Typography>
  </Box>
);

export const ClientDataCard = () => {
  const { orderData } = useClientZS();

  const order = orderData || {};

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: theme => theme.shadows[2]
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          mb={5}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: 'primary.lighter',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <BusinessOutlinedIcon color="primary" />
          </Box>

          <Typography
            variant="h4"
            fontWeight={700}
          >
            Dane klienta
          </Typography>
        </Stack>

        {/* Dane podstawowe */}

        <Typography
          variant="h6"
          fontWeight={700}
          mb={3}
        >
          Dane podstawowe
        </Typography>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={4}
          mb={4}
        >
          <InfoField
            label="Imię i nazwisko"
            value={[
              order.office_representative_name,
              order.office_representative_surname
            ]
              .filter(Boolean)
              .join(' ') || '-'}
          />

          <InfoField
            label="NIP"
            value={order.school_nip}
          />
        </Stack>

        <Divider sx={{ my: 4 }} />

        {/* Kontakt */}

        <Typography
          variant="h6"
          fontWeight={700}
          mb={3}
        >
          Dane kontaktowe
        </Typography>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={4}
          mb={5}
        >
          <InfoField
            label="E-mail"
            value={order.office_representative_correspondence_email}
          />

          <InfoField
            label="Telefon"
            value={order.office_representative_phone}
          />

          <InfoField
            label="Dodatkowy telefon"
            value={order.office_representative_additional_phone}
          />
        </Stack>

        <Divider sx={{ my: 4 }} />

        {/* Adres */}

        <Typography
          variant="h6"
          fontWeight={700}
          mb={3}
        >
          Adres
        </Typography>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={4}
          mb={4}
        >
          <InfoField
            label="Ulica"
            value={order.school_street_address}
          />

          <InfoField
            label="Kod pocztowy"
            value={order.school_postal_code}
          />
        </Stack>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={4}
        >
          <InfoField
            label="Miasto"
            value={order.school_city}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};
